import { React, _ } from '../../../lib';
import { reactFlyout } from '../../component-react';
import { FormComponent } from './render';
export const openFlyoutForm = (input) => {
    const [width, maxHeight] = input.size;
    const fieldHeight = _.chain(input.fields)
        .filter(x => _.isFunction(x.hidden) || !x.hidden)
        .map(x => x.height)
        .sum()
        .value();
    const buttonHeight = 70;
    const titleHeight = 42;
    const paddingHeight = 20;
    const fullHeight = fieldHeight + buttonHeight + titleHeight + paddingHeight;
    const height = _.min([fullHeight, maxHeight ?? 99999]) ?? 99999;
    reactFlyout(null, [width, height], React.createElement(FormComponentFlyoutWrapper, { value: null, onUpdate: () => { }, ...input }));
};
const FormComponentFlyoutWrapper = (props) => (React.createElement("div", { className: "tailwind-wrapper" },
    React.createElement("div", { className: "font-condensed text-[32px] leading-10 font-light px-[2px]" }, props.title),
    React.createElement(FormComponent, { ..._.omit(props, ['title', 'disableAutoFocus', 'flyout']), onMount: () => {
            if (!props.disableAutoFocus) {
                const firstInput = props.flyout?.Element.querySelector('input:not(:disabled), select:not(:disabled), textarea:not(:disabled)');
                firstInput?.focus();
            }
            else {
                props.flyout?.Element.querySelector('form')?.focus();
            }
            props.onMount?.();
        }, onSuccessfulSave: () => {
            props.onSuccessfulSave?.();
            props.flyout?.Close();
        }, excludeReset: true, extraActions: [
            {
                lbl: 'Cancel',
                type: 'standard',
                onClick: () => {
                    props.flyout?.Close();
                },
            },
            ...(props.extraActions ?? []),
        ] })));
//# sourceMappingURL=flyout.js.map